var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatternLeftBottom(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pattern-left-bottom_svg__Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 240 144",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".pattern-left-bottom_svg__st1{fill:#4f25b7}.pattern-left-bottom_svg__st4{fill:#6c36db}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    className: "pattern-left-bottom_svg__st1",
    d: "M192 96h48v48h-48V96zM144 48h48v48h-48V48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 144h48v-24h-24V96h-24v48z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#c193ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 96H48V72h24V48h24v48z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#6c36db"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pattern-left-bottom_svg__st4",
    d: "M0 48h48L0 0v48zM144 144H96V96c26.5 0 48 21.5 48 48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 48H48V0c26.5 0 48 21.5 48 48z",
    fill: "#ad78ff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pattern-left-bottom_svg__st4",
    d: "M48 144H10c-5.5 0-10-4.5-10-10V96c26.5 0 48 21.5 48 48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 96h24c-13.3 0-24 10.7-24 24V96zm24 48H48v-24c0 13.3 10.7 24 24 24zm24-24v24H72c13.3 0 24-10.7 24-24zm0 0V96H72c13.3 0 24 10.7 24 24zm-24 9.6c5.3 0 9.6-4.3 9.6-9.6s-4.3-9.6-9.6-9.6-9.6 4.3-9.6 9.6 4.3 9.6 9.6 9.6z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ad78ff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternLeftBottom);
export default "/_next/static/images/6eb6f7fd77b60f259c55f28ff9a2e867.svg";
export { ForwardRef as ReactComponent };